// Engine
import output from "_src/engine/output";
import {stepType, selectionType} from "_src/constants";
import selector from "_src/manipulators/libs/selector";

// Application
import workspace from "_src/workspace";
import history from "_src/history/manager";
import projectTree from "_src/reformer/project_tree";

export default {

  setObjectColor({id, color}) {

    const object = workspace.getGroupByID(id) || workspace.getObjectByID(id);

    if (!object) {
      output.error(output.API_ERROR, "Can't set object color. Wrong object id: \"" + id + "\"");
      return false;
    }

    const {r, g, b} = color;

    object.setColor(r, g, b);

    return true;

  },

  async setObjectVisibility({objectID, l1IDx, l2IDx, visible = true}) {
    const object = workspace.getGroupByID(objectID) || workspace.getObjectByID(objectID) || workspace.getPhotoGroupByID(objectID) || workspace.getMeasureByID(objectID);

    if (!object) {
      output.error(output.API_ERROR, "Can't set object visibility. Wrong object id: \"" + objectID + "\"");
      return false;
    }

    if (l1IDx !== undefined || l2IDx !== undefined) {
      projectTree.setSubSectionProperty(objectID, l1IDx, l2IDx, "visible", visible);
    } else {
      if (object.getVisibility() === visible) {
        return false;
      }
      await workspace.setObjectVisibility(object, visible);
    }
  },

  clearSelection(objects) {
    const changedObjects = [];

    for (const object of objects) {
      let changed = false;
      for (const frame of object.frames) {
        const updatedChunks = [];
        for (const chunk of frame.model.chunks) {
          if (chunk.geometry.checkHasSelectedVertices()) {
            updatedChunks.push(chunk.getID());
          }
        }

        if (updatedChunks.length > 0) {
          history.writeFrameToCurrentStep({type: stepType.SELECT, frame: frame, chunksUp: updatedChunks});
          changed = true;
        }
      }

      if (changed) {
        selector.dropSelection(object);
        changedObjects.push({id: object.id});
      }
    }

    if (changedObjects.length > 0) {
      history.addStep(stepType.SELECT, {type: selectionType.CLEAR, objects: changedObjects});
    }

  },

  invertSelection(objects) {
    const changedObjects = [];

    for (const object of objects) {
      for (const frame of object.frames) {
        const updatedChunks = [];
        for (const chunk of frame.model.chunks) {
          updatedChunks.push(chunk.getID());
        }

        if (updatedChunks.length > 0) {
          history.writeFrameToCurrentStep({type: stepType.SELECT, frame: frame, chunksUp: updatedChunks});
        }
      }

      selector.invertSelection(object);
      changedObjects.push({id: object.id});
    }

    if (changedObjects.length > 0) {
      history.addStep(stepType.SELECT, {type: selectionType.INVERT, objects: changedObjects});
    }

  },

  async invertNormals(objects) {
    const promises = [];
    for (const object of objects) {
      for (const frame of object.frames) {
        for (const chunk of frame.model.chunks) {
          promises.push(chunk.invertNormals(false));
        }
      }
    }

    await Promise.all(promises);
  },

  async closeProject() {
    workspace.clearLoader();
    await workspace.closeProject();
  },

  cleanup() {
    workspace.cleanup();
    workspace.closeProject();
  }

}
